export default { sha: '80dd5ec08d4fca5d078523b49ae0fbd83598e7e2', buildNumber: 'undefined' }
